
// Define the possible roles (must match what's in AuthContext)
export type Role = "medewerker" | "planner" | "management";

// Define the possible companies
export type Company = "luijten_vvz" | "decoprof";

// Define different permission types
export type PermissionType = "read" | "write" | "delete";

// Define the different resources (modules)
export type Resource = 
  | "dashboard" 
  | "orders" 
  | "inventory" 
  | "notifications" 
  | "reports" 
  | "medewerkers"
  | "feedback"
  | "packagePickup"
  | "rollenbeheer"
  | "gebruikersbeheer"
  | "registraties"
  | "nieuws"
  | "workflowExecutions"
  | "expiredProducts"
  | "nieuweProducten"
  | "apiDocs"
  | "kleurenOrders"
  | "packers";

// Permission definition
export interface Permission {
  id: string;
  role: Role;
  resource: Resource;
  company: Company;
  read: boolean;
  write: boolean;
  delete: boolean;
}

// Resource display labels
export const resourceLabels: Record<Resource, string> = {
  dashboard: "Dashboard",
  orders: "Orders",
  inventory: "Voorraad",
  notifications: "Meldingen",
  reports: "Rapportages",
  medewerkers: "Medewerkers",
  feedback: "Feedback",
  packagePickup: "Pakket Ophaaltijden",
  rollenbeheer: "Rollenbeheer",
  gebruikersbeheer: "Gebruikersbeheer",
  registraties: "Registratie Aanvragen",
  nieuws: "Nieuws+",
  workflowExecutions: "Workflow Executions",
  expiredProducts: "Vervallen Producten",
  nieuweProducten: "Nieuwe Producten",
  apiDocs: "API Documentatie",
  kleurenOrders: "Kleuren Orders",
  packers: "Packers",
};

// Company display labels
export const companyLabels: Record<Company, string> = {
  luijten_vvz: "Luijten VVZ",
  decoprof: "Decoprof",
};
